import Vue from "vue";
import getVideoId from "get-video-id";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "@/plugins/vuetify";
import i18n from "@/plugins/i18n";
import "./styles/app.scss";

Vue.config.productionTip = false;
Vue.prototype.getVideoId = getVideoId;
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
